import { FiUser, FiUserCheck, FiShield, FiInfo } from "react-icons/fi";
import { OWNERSHIP_RULES, WEIGHT_OWNERS } from "../../utils/constants";

const OWNER_TONE = {
  [WEIGHT_OWNERS.EMPLOYEE]: "primary",
  [WEIGHT_OWNERS.MANAGER]: "info",
  [WEIGHT_OWNERS.HR]: "neutral",
};

const OWNER_ICON = {
  [WEIGHT_OWNERS.EMPLOYEE]: FiUser,
  [WEIGHT_OWNERS.MANAGER]: FiUserCheck,
  [WEIGHT_OWNERS.HR]: FiShield,
};

export function OwnerBadge({ owner, children }) {
  const Icon = OWNER_ICON[owner] || FiUser;
  return (
    <span className={`badge badge-${OWNER_TONE[owner] || "neutral"}`}>
      <Icon size={12} aria-hidden="true" />
      {children || owner}
    </span>
  );
}

export default function OwnershipPanel({ view = "employee", highlight, compact = false }) {
  const you = view === "manager" ? "manager" : "employee";

  return (
    <div className={`ownership-panel ${compact ? "is-compact" : ""}`}>
      <table className="data-table ownership-table">
        <thead>
          <tr>
            <th scope="col">Stage</th>
            <th scope="col" className={you === "employee" ? "is-you" : ""}>
              Employee {you === "employee" && <span className="you-chip">you</span>}
            </th>
            <th scope="col" className={you === "manager" ? "is-you" : ""}>
              Manager {you === "manager" && <span className="you-chip">you</span>}
            </th>
            <th scope="col">Final say</th>
          </tr>
        </thead>
        <tbody>
          {OWNERSHIP_RULES.map((rule) => (
            <tr key={rule.stage} className={highlight && highlight !== rule.stage ? "is-dim" : ""}>
              <th scope="row" className="ownership-stage">{rule.stage}</th>
              <td className={you === "employee" ? "is-you" : ""}>{rule.employee}</td>
              <td className={you === "manager" ? "is-you" : ""}>{rule.manager}</td>
              <td><OwnerBadge owner={rule.decidedBy} /></td>
            </tr>
          ))}
        </tbody>
      </table>
      <p className="ownership-note">
        <FiInfo size={14} aria-hidden="true" />
        <span>
          Weights always total <strong>exactly 100%</strong> per plan. Each person edits only the goals they created. The manager
          sends the sheet back with Request changes, and after approval a change request (approved by the manager) reopens it.
        </span>
      </p>
    </div>
  );
}
